'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    DragItemTypes = require('../constants/DragItemTypes'),
    SectionTypes = require('../constants/SectionTypes'),
    MediaTypes = require('../constants/MediaTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { DragDropMixin } = require('react-dnd'),
    { PropTypes } = React;

require('./AddSectionButton.less');

var BUTTONS = {
  'poster': {
    title: 'Fullscreen',
    icon: 'poster',
    sectionType: SectionTypes.POSTER
  },
  'gallery': {
    title: 'Set',
    icon: 'set',
    sectionType: SectionTypes.GALLERY
  },
  'text': {
    title: 'Text',
    icon: 'text',
    sectionType: SectionTypes.TEXT
  },
  'audio': {
    title: 'Audio',
    icon: 'audio',
    sectionType: SectionTypes.MEDIA,
    options: {
      mediaType: MediaTypes.AUDIO_TRACK
    }
  },
  'video': {
    title: 'Video',
    icon: 'video',
    sectionType: SectionTypes.MEDIA,
    options: {
      mediaType: MediaTypes.VIDEO
    }
  }
};

var AddSectionButton = React.createClass({
  mixins: [ClassNameMixin, DragDropMixin, PureRenderMixin],

  className: 'editor-AddSectionButton',

  propTypes: {
    isLast: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(Object.keys(BUTTONS)).isRequired,
    onClick: PropTypes.func.isRequired,
    onDrop: PropTypes.func
  },

  getCSSModifiers() {
    var { isDragging } = this.getDropState(DragItemTypes.IMAGE),
        isLast = this.props.isLast;

    return [
      isDragging && 'drop',
      isLast && 'last'
    ];
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.IMAGE, {
      dropTarget: {
        canDrop() {
          return !!this.props.onDrop;
        },

        acceptDrop(item) {
          var sectionType = BUTTONS[this.props.type].sectionType,
              options;

          switch (sectionType) {
          case SectionTypes.POSTER:
            options = { background: item.image };
            break;
          case SectionTypes.GALLERY:
            options = { images: [item.image] };
            break;
          }
          this.props.onDrop(sectionType, options);
        }
      }
    });
  },

  render() {
    var { type, isLast } = this.props,
        { isDragging, isHovering } = this.getDropState(DragItemTypes.IMAGE);

    return (
      <div className={this.getClassName()}
           data-hint={isDragging}
           data-hover={isHovering}
           {...this.dropTargetFor(DragItemTypes.IMAGE)}>

        {isDragging &&
          <Icon name={BUTTONS[type].icon}
                size={isLast ? 'medium' : 'small'}
                mode='stroke' />
        }

        {!isDragging &&
          <Button size={isLast ? 'xlarge' : 'medium'}
                  onClick={this.handleClick}
                  color='green'
                  fill
                  round={!isDragging}>
            <Icon name={BUTTONS[type].icon}
                  size={isLast ? 'medium' : 'small'}
                  mode='stroke' />
          </Button>
        }

        {(isDragging || isLast) &&
          <span className='editor-AddSectionButton-label'>
            {BUTTONS[type].title}
          </span>
        }
      </div>
    );
  },

  handleClick() {
    var { sectionType, options } = BUTTONS[this.props.type];
    this.props.onClick(sectionType, options);
  }
});

module.exports = AddSectionButton;



/** WEBPACK FOOTER **
 ** ./editor/AddSectionButton.jsx
 **/